/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
    array,
    func,
    object,
    string,
    number,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';

import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getBrand } from '../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';

/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-wrap-multilines */

const styles = (theme) => ({
    radio: {
        padding: 0,
        paddingRight: '5px',
        fontSize: '14px',
        '&$checked': {
            color: theme?.palette?.checkRadioBtn,
        },
        '& svg': {
            fontSize: '14px',
        },
    },
    checked: {
        color: theme?.palette?.checkRadioBtn,
    },
    menuItem: {
        fontSize: '14px',
    },
    checkbox: {
        padding: 0,
        paddingRight: '5px',
        fontSize: '14px',
        color: theme?.palette?.common?.black,
        '& svg': {
            fontSize: '16px',
        },
        '&$checked': {
            color: theme?.palette?.checkRadioBtn,
        },
    },
    expandMoreBtn: {
        height: '22px',
        '& svg': {
            height: '22px',
        },
    },
    filterCount: {
        marginLeft: 'auto',
        fontWeight: 'bolder',
    },
    subNav: {
        backgroundColor: '#FFF',
        zIndex: 99,
        minWidth: '200px',
    },
    filterOptionText: {
        cursor: 'pointer',
    },

});
const FilterMenuBarItem = ({
    classes, title, filterOption, checkedOptions, setFacetsOptions, facetsData, setFilterOptions, totalCount,
}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [selectedValue, setSelectedValue] = useState('Best Sellers');
    const containerRef = useRef();
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const brand = useSelector(getBrand);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef?.current && anchorRef?.current?.contains(event?.target)) {
            return;
        }

        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event?.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen?.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    const setFilterData = (filter) => {
        dispatch(trackEvent({
            eventCategory: 'Collection Page',
            eventAction: 'Filter Interaction - Selected',
            eventLabel: `${title} - ${filter}`,
            filters_product_count: totalCount,
            eventName: 'feature_interaction',
            filter_name: title || '',
        }));
        switch (filter) {
            case 'Best Sellers':
                return setFilterOptions({ sellingBtn: true, highToLowBtn: false, lowToHighBtn: false });
            case 'Price: High to Low':
                return setFilterOptions({ sellingBtn: false, highToLowBtn: true, lowToHighBtn: false });
            case 'Price: Low to High':
                return setFilterOptions({ sellingBtn: false, highToLowBtn: false, lowToHighBtn: true });
            /* case 'A to Z':
                setSellingBtn(false);
                setHighToLowBtn(true);
                setLowToHighBtn(false);
                break;
            case 'Z to A':
                setSellingBtn(false);
                setHighToLowBtn(false);
                setLowToHighBtn(true);
                break; */
            default:
                setFilterOptions({ sellingBtn: true, highToLowBtn: false, lowToHighBtn: false });
                return null;
        }
    };

    const handleRadioClick = (itemName) => {
        setSelectedValue(itemName);
        setFilterData(itemName);
    };

    const handleCheckboxClick = (selectedFilterOption) => {
        if (selectedFilterOption === '') return;
        const value = selectedFilterOption;
        let checkedArr = [];
        const delimiter = '&';
        if (checkedOptions && value) {
            checkedArr = [...facetsData];
            if (checkedArr.some((check) => check === value)) {
                checkedArr = checkedArr.filter((check) => check !== value);
            } else {
                checkedArr.push(value);
            }
            dispatch(trackEvent({
                eventCategory: 'Collection Page',
                eventAction: 'Filter Interaction - Selected',
                eventLabel: `${title} - ${value}`,
                filters_product_count: totalCount,
                filters_page_url: checkedArr.join(delimiter),
                eventName: 'feature_interaction',
                filter_name: title || '',
            }));
            setFacetsOptions(checkedArr);
        }
        const urlSelectedParams = checkedArr.join(delimiter);
        history.replace({
            search: `${urlSelectedParams ? `facet=${urlSelectedParams}` : ''}`,
            state: checkedArr,
        });
    };

    const renderMultiCheckFacetList = (name, value) => {
        let isChecked = false;
        if (facetsData?.length) {
            isChecked = facetsData.includes(value);
        }
        return (
            <Checkbox
                inputProps={{ 'aria-label': 'controlled' }}
                color="primary"
                role="menuitem"
                disableRipple
                name={name}
                value={value}
                checked={isChecked}
                onChange={() => handleCheckboxClick(value)}
                classes={{
                    root: classes.checkbox,
                    checked: classes.checked,
                }}
            />);
    };

    const renderSingleCheckFacetList = (item) => {
        let isChecked = false;
        if (selectedValue !== '') {
            isChecked = !selectedValue?.indexOf(item);
        }
        return (
            <Radio
                checked={isChecked}
                label={item}
                value={item}
                name="radio-buttons"
                role="menuitem"
                onChange={() => handleRadioClick(item)}
                classes={{
                    root: classes.radio,
                    checked: classes.checked,
                }}
            />
        );
    };

    const renderMenuItem = (menuTitle, options) => {
        let MenuItemUI = null;

        if (options?.length > 0) {
            MenuItemUI =  options?.map((item) => {
                if ((menuTitle === 'Sort') || (item?.count > 0)) {
                    return (
                        <MenuItem
                            role="menuitem"
                            key={`${menuTitle || item?.name}`}
                            classes={{
                                root: classes.menuItem,
                            }}
                            onClick={title === 'Sort' ? () => handleRadioClick(item) : () => handleCheckboxClick(item?.value)}
                        >
                            { item?.name
                                ? renderMultiCheckFacetList(item.name, item.value) : renderSingleCheckFacetList(item) }
                            <label className={classes.filterOptionText} htmlFor={item?.name || item}>{item?.name || item}</label>
                            {brand?.code === 'CAN' && item?.count && <span className={classes.filterCount}>{item?.count}</span>}
                        </MenuItem>
                    );
                }
                return null;
            });
        }
        return MenuItemUI;
    };

    const expandButton = (
        open ? <ExpandLess data-testid="expand-less-icon" /> : <ExpandMore data-testid="expand-more-icon" />
    );

    return (
        <div className="menu-bar" role="menu" ref={containerRef}>
            <Button
                className="menu-button"
                role="menuitem"
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleToggle}
                ref={anchorRef}
                title={title}
                aria-label={title}
                aria-labelledby="filter item title"
            >
                {title}
                <span className={classes.expandMoreBtn}>{expandButton}</span>
            </Button>

            <Popper
                open={open}
                anchorEl={anchorRef?.current}
                role={undefined}
                transition
                disablePortal
                className={classes.subNav}
                placement="bottom-start"
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                    { renderMenuItem(title, filterOption) }
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </div>
    );
};

FilterMenuBarItem.propTypes = {
    classes: object.isRequired,
    title: string.isRequired,
    filterOption: array.isRequired,
    checkedOptions: array.isRequired,
    facetsData: array.isRequired,
    setFacetsOptions: func.isRequired,
    setFilterOptions: func.isRequired,
    totalCount: number.isRequired,
};

export default withStyles(styles)(FilterMenuBarItem);
